const PRICING_TYPE = Object.freeze({
  role: 'role',
  service: 'service',
  unknown: 'unknown',
});

// noinspection JSUnusedGlobalSymbols
export default PRICING_TYPE;
